  <div class="checkbox-block my-4" *ngIf="isToggleVisibility">
    <div class="h-fit">
      <div class="form-check form-check-inline ps-0 table-checkbox" 
           *ngFor="let column of columns"
           >
        <input class="form-check-input" 
               type="checkbox" 
               [id]="column.key"
               [checked]="column.visible" 
               (change)="toggleColumnVisibility(column.key)" 
               />
        <label class="form-check-label" 
               [for]="column.key"
               >
               {{ column.label }}
        </label>
      </div>
      <button pButton 
              class="reset-visibility-btn"
              pRipple 
              *ngIf="isAnyColumnHidden()"
              (click)="resetColumnVisibility()"
              >
              Reset Visibility
      </button>
    </div>

    <mat-slide-toggle *ngIf="isSearch" 
                      [disableRipple]="false" 
                      [(ngModel)]="showFilter"
                      placement="bottom"
                      [tooltip]="!showFilter ? 'This action will enable search in the table.' : 'This action will disable search in the table.'"
                      >
                      Search {{ showFilter ? 'enable' : 'disable' }}
    </mat-slide-toggle>

  </div>

  <div class="card-body px-0"  #tableContainer style="overflow: auto;">
  <div class="table-responsive">
      <p-table 
      [value]="tableData" 
      [paginator]="paginator"  
      [rows]="rowsPerPage" 
      [totalRecords]="totalRecords"  
      [tableStyle]="{'min-width': '60rem'}" 
      [rowsPerPageOptions]="[20, 50, 100]"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      (onSort)="onSort($event)"
      [lazy]="true" 
      [currentPageReportTemplate]="'Showing {first} to {last} of {totalRecords} entries'" 
      [showJumpToPageDropdown]="true"
      (onPage)="onPageChange($event)"
      emptyMessage="'No data available'"
      >      
  
        <ng-template pTemplate="header">
          <tr>
            <ng-container *ngFor="let column of columns; let i = index">
              <th class="custom-th" *ngIf="column.visible" [pSortableColumn]="i !== 0 ? column.key : null" [style.width]="column.width">
                <div class="table-header">
                  <div class="table-header-content">
                    <!-- {{ column.label }}  -->
                    <span class="label">{{ column.label }}</span>
                    <span *ngIf="isSortIcon">
                      <p-sortIcon *ngIf="i !== 0" [field]="column.key"></p-sortIcon>
                    </span>
                  </div>
                  <input *ngIf="showFilter" 
                         type="text" 
                         pInputText 
                         (input)="onFilterChange(column.key, $event.target.value)" 
                         (click)="$event.stopPropagation()" 
                         [placeholder]="column.label">
                </div>
              </th>
            </ng-container>
            
          </tr>
        </ng-template>
  
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <ng-container *ngFor="let column of columns">
              <td class="custom-td" *ngIf="column.visible" [ngStyle]="{'background-color': column.bgColor || 'transparent'}">
                <ng-container *ngIf="column.templateRef; else defaultContent">
                  <ng-container *ngTemplateOutlet="column.templateRef; 
                                                   context: { $implicit: rowData }"
                                                   >
                  </ng-container>
                </ng-container>
                <ng-template #defaultContent>
                  <!-- {{ rowData[column.key] }} -->
                  {{ rowData[column.key] != null && rowData[column.key] !== '' ? rowData[column.key] : '--' }}
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </ng-template>

        <div *ngIf="!tableData || tableData.length === 0" class="text-center">
          No data available
        </div>
  
    </p-table>
    </div>
  </div>
  
  